/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */






// document.addEventListener('variant:changed', function (event) {
// debugger;
//   const variant = event.detail.variant;
//   if (!variant) return;

//   const preorderContainer = document.getElementById('preorder-container');
//   const preorderCheckbox  = document.getElementById('pre-order-checkbox');
//   const warning           = document.getElementById('preorder-warning');
//   const addToCartBtn      = document.getElementById('buybtn');

//   if (!addToCartBtn) return;

//   // 🔑 METAFIELD RESOLUTION (CORRECT WAY)
//   const isPreorder = window.variantPreorderMap?.[variant.id] === true;
//   const inventory  = variant.inventory_quantity;

//   if (isPreorder) {
//     // PRE-ORDER MODE
//     preorderContainer.style.display = 'block';
//     preorderCheckbox.required = true;

//     addToCartBtn.disabled = false;
//     addToCartBtn.textContent = 'Pre Order';

//   } else {
//     // NORMAL MODE
//     preorderContainer.style.display = 'none';
//     preorderCheckbox.checked = false;
//     preorderCheckbox.required = false;
//     warning.style.display = 'none';

//     if (inventory > 0) {
//       addToCartBtn.disabled = false;
//       addToCartBtn.textContent = 'Add to Cart';
//     } else {
//       addToCartBtn.disabled = true;
//       addToCartBtn.textContent = 'Out of Stock';
//     }
//   }
// });

// // Enforce checkbox before submit (bind once)
// document.addEventListener('click', function (e) {
//   const btn = document.getElementById('buybtn');
//   const checkbox = document.getElementById('pre-order-checkbox');
//   const container = document.getElementById('preorder-container');
//   const warning = document.getElementById('preorder-warning');

//   if (
//     e.target === btn &&
//     container?.style.display === 'block' &&
//     !checkbox?.checked
//   ) {
//     e.preventDefault();
//     warning.style.display = 'block';
//   }
// });





    $(".my-custom-class").on("click", function (e) {
      debugger;
      if (!$("#pre-order").is(":checked")) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $("#preorder-warning").fadeIn();
        return false;
      }

    });

    $("#pre-order").on("change", function () {

      if (this.checked) {
        $("#preorder-warning").fadeOut();
        $("#pre-order__add-button").removeClass("is-disabled");
      } else {
        $("#pre-order__add-button").addClass("is-disabled");
      }

    });

